import httpClient from "../config/httpClient";
import { ProductDependencyDto } from "./model";

export abstract class DataDependencyService {
	private static readonly BASE_URL = "/sys03/data/dependency";

	public static fetchGroups() {
		const url = `${DataDependencyService.BASE_URL}/groups`;

		return httpClient.get<ProductDependencyDto[]>(url).then((response) => response.data);
	}

	public static fetchNonGroups() {
		const url = `${DataDependencyService.BASE_URL}/nongroups`;

		return httpClient.get<ProductDependencyDto[]>(url).then((response) => response.data);
	}
}
